import { SET } from '..';
import { UserService } from '@/services';

export default {
	namespaced: true,
	state: {
		userTags: [],
		lastVisitedSalons: []
	},
	getters: {
		getLastVisitedSalons: state => size => {
			return state.lastVisitedSalons?.slice(0, size || state.lastVisitedSalons.length);
		}
	},
	mutations: {
		SET
	},
	actions: {
		async getUserTags({ commit }) {
			const userTags = await UserService.GetUserTags();

			if (userTags) {
				commit('SET', { key: 'userTags', value: userTags });
			}

			return userTags;
		},
		async getLastVisitedSalons({ commit }) {
			const lastVisitedSalons = await UserService.GetLastVisitedSalons();

			if (lastVisitedSalons) {
				commit('SET', { key: 'lastVisitedSalons', value: lastVisitedSalons });
			}else{
				commit('SET', { key: 'lastVisitedSalons', value: [] });
			}

			return lastVisitedSalons;
		},
		async userLoggedInActions({ dispatch }, payload) {
			if(payload.route.path.includes('nettbutikk')){
				// if exists, update webshop cart from localstorage
				await dispatch('clickAndCollect/saveCartFromLocalStorageToDb', {
					chainId: parseInt(payload.route.params.chainId),
					userId: payload.user.membershipProfileId,
					onlineSluttKundeId: payload.user.onlineSluttKundeId
				}, {root: true});

				// on login get users buy history
				await dispatch('userBehavior/fetchPurchaseHistory', {
					chainId: payload.route.params.chainId,
					onlineSluttKundeId: payload.user.onlineSluttKundeId,
					siteId: 0
				}, {root: true})
			}
		},

		async userLoggedOut ({dispatch}) {
			await dispatch('userBehavior/setPurchaseHistory', [], {root: true})
		},
		async logout() {
			return await UserService.Logout()
		},
		async LoginByJwt(){
			return await UserService.LoginByJwt()
		},

		async getOnlineSluttKunde({commit}) {
			return await UserService.GetOnlineSluttKunde()
		},
		async updateProfile({commit}, params) {
			return await UserService.UpdateProfile(params)
		},

		async deleteProfile({commit}) {
			return await UserService.DeleteProfile()
		},

		async getConsents({commit}, params) {
			return await UserService.GetConsents(params)
		},

		async updateConsents({commit}, params) {
			return await UserService.UpdateConsent(params)
		},

		async requestPersonalInformation({commit}, params){
			return await UserService.RequestPersonalInformation(params)
		}
	}
};
